import store from '@/store'
/**
 * Remove (previous) error banner when necessary.
 */
export const transitionNetworkStatus = () => {
  const current = store.state.networkResponse?.status ?? null;
  const statuses = store.state.STATUSES;

  if (current !== statuses.SUCCESS && current !== statuses.SERVER_ERR) {
    // update network status to an intermediate state until the next network call
    store.dispatch('setTransitionalNetworkStatus').then();
  }
};

/**
 * IE not supported.
 */
export const validateBrowser = () => {
  const ua = window.navigator.userAgent;
  // any IE, including non-Chrome Edge (but not Chromium-based Edge)
  const isIE = /Edge\/|Trident\/|MSIE/.test(ua);
  if (isIE) {
    window.location.replace('noie.html');
  }
};

